import { ApplicationState } from 'application/redux';
import { goToFirstPage } from 'core/pagination-optimized/redux/actions';
import { connect } from 'react-redux';
import {
  onChangeCurrentComparator,
  onChangeCurrentFilterValue,
  onSelectFilter,
  toggleMoreFilters,
  translateFilter,
  updateDays,
} from './redux/action';
import SearchComponent from './search-component';

const mapStateToProps = (state: ApplicationState, ownProps: any) => ({
  onSearch: ownProps.onSearch,
  search: state.search,
  t: state.i18n.t
});

export default connect(mapStateToProps, {
  onChangeCurrentFilterValue,
  onChangeCurrentComparator,
  onSelectFilter,
  toggleMoreFilters,
  updateDays,
  translateFilter,
  goToFirstPage,
})(SearchComponent);
